import _test from "ramda/src/test";
import _identity from "ramda/src/identity";
import _ifElse from "ramda/src/ifElse";
import _useWith from "ramda/src/useWith";
import _assoc from "ramda/src/assoc";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toPairs from "ramda/src/toPairs";
import _curry from "ramda/src/curry";
import _either from "ramda/src/either";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isArray, isObject } from "../../../browser/is";
import { mapDeep } from "../../../browser/object";
var isArrayOrObject = _either(isArray, isObject);
export var flattenKeysFrom = _curry(function (prefix, query) {
  return _toPairs(query).reduce(function (flat, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    var flatKey = prefix ? "".concat(prefix, "[").concat(key, "]") : key;
    return _typeof(val) === 'object' ? _objectSpread(_objectSpread({}, flat), flattenKeysFrom(flatKey, val)) : _assoc(flatKey, val, flat);
  }, {});
});
export var mapDeepWithArr = _useWith(mapDeep, [function (pred) {
  return _ifElse(isArrayOrObject, mapDeepWithArr(pred), pred);
}, _identity]);
export var couldBeValidNumber = _test(/^[0-9]+(\.[0-9]+)?$/);